import { useState } from 'react';

import { JobProfileType } from 'Views/JobProfile/JobProfile.enums';

type useModalAssignJobProfileProps = {
	handleAssignJobProfile: (risk: string) => void;
	handleClose: () => void;
};

export const useModalAssignJobProfile = ({
	handleAssignJobProfile,
	handleClose,
}: useModalAssignJobProfileProps) => {
	const [kindOfProfile, setKindOfProfile] = useState(
		JobProfileType.RISK_PROFILE,
	);
	const [step, setStep] = useState(0);

	const [selectedRiksProfile, setSelectedRiksProfile] = useState({
		id: '',
		value: 'Selecione...',
	});
	const [selectedExpositionArea, setSelectedExpositionArea] = useState({
		id: '',
		value: 'Selecione...',
	});

	const handleNext = async () => {
		if (step === 0) {
			setStep((prev) => prev + 1);
			return;
		}
		await handleAssignJobProfile(
			kindOfProfile === JobProfileType.RISK_PROFILE
				? selectedRiksProfile.id
				: selectedExpositionArea.id,
		);
		handleClose();
	};

	const handleChangeKingOfProfile = (value: JobProfileType) => {
		setKindOfProfile(value);
	};

	const handleSelectRiskProfile = (value: any) => {
		setSelectedRiksProfile(value);
	};

	const handleSelectExpositionArea = (value: any) => {
		setSelectedExpositionArea(value);
	};

	return {
		step,
		kindOfProfile,
		selectedRiksProfile,
		selectedExpositionArea,
		handleNext,
		handleChangeKingOfProfile,
		handleSelectRiskProfile,
		handleSelectExpositionArea,
	};
};
